import { render, staticRenderFns } from "./booking-list-tab.vue?vue&type=template&id=d958ff4c&scoped=true&"
import script from "./booking-list-tab.vue?vue&type=script&lang=js&"
export * from "./booking-list-tab.vue?vue&type=script&lang=js&"
import style0 from "./booking-list-tab.vue?vue&type=style&index=0&id=d958ff4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d958ff4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
